// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"f63130ef","453":"b173f9e3","455":"903183c7","599":"5cff3a87","977":"17e9e458"}[chunkId] + ".chunk.js";
};